// extracted by mini-css-extract-plugin
export var cardContainer = "_p5-0";
export var cardHeader = "_p5-2";
export var collapsedState = "_p5-3";
export var dragHandle = "_p5-5";
export var dragHandleIcon = "_p5-6";
export var dragging = "_p5-1";
export var titleArea = "_p5-4";